<template>
  <div>
    <sweet-modal width="1400" blocking title="Journal Entry" ref="createJournalEntry" class="modal" v-on:close="closeCreateJournalEntry">
      <el-form :model="form" label-position="right" size="mini" ref="form" status-icon :rules="rules" class="demo-ruleForm">

        <el-row :gutter="20" style="margin-bottom: 40px;">
          <el-col :span="8" :offset="0">

            <el-row>
              <!-- Entry Type -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="115px" label="Entry Type">
                  <el-select :disabled="buttonAdd" v-model="form.entryType" placeholder="Entry Type" filterable style="width: 100%;">
                    <el-option v-for="item in entryTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- Journal Date -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="115px" label="Journal Date" prop="journalDate">
                  <el-date-picker
                    :disabled="buttonAdd"
                    v-model="form.journalDate"
                    :clearable='false'
                    format="d MMM yy"
                    value-format="MM-dd-yyyy"
                    type="date"
                    placeholder="Pick a day">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- Tax (Amounts Are) -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="130px" label="Tax (Amounts Are)">
                  <el-select :disabled="buttonAdd" style="width:100%" v-model="form.tax" placeholder="Tax (Amounts Are)" @change="changeTax()">
                    <el-option
                      v-for="item in taxList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="8" :offset="0">

            <el-row>
              <!-- Currency -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="115px" label="Currency" prop="currencyName">
                  <el-select :disabled="buttonAdd" style="width:38%" v-model="form.currencyName" placeholder="Currency" filterable>
                    <el-option
                      v-for="item in currencyList"
                      :key="item.id"
                      :label="item.code"
                      :value="item.code"
                      @click.native="changeCurrency(item)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- Exchange Rate -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="120px" label="Exchange Rate" prop="exchangeRate">
                  <el-row :gutter="10">
                    <el-col :span="9" :offset="0">
                      <money
                        v-model="form.exchangeRate"
                        v-bind="moneyRate"
                        :readonly="currencyCompany.code === form.currencyName || buttonAdd"
                        style="text-align: right;"></money>
                    </el-col>
                    <el-col :span="5" :offset="0">
                      <el-tag type="info" v-html="currencyCompany.code"></el-tag>
                    </el-col>
                    <el-col :span="9" :offset="0">
                      <div style="text-align: right;">{{ totalForRate }}</div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <!-- Recorded Date -->
              <el-col :span="24" :offset="0" v-if="status === 'Recorded'">
                <el-form-item label-width="115px" label="Recorded Date">
                  <el-date-picker
                    disabled
                    v-model="form.recorderDate"
                    format="d MMM yy"
                    value-format="MM-dd-yyyy"
                    type="date"
                    placeholder="Pick a day">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- Description -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="115px" label="Description" prop="description">
                  <el-input :disabled="buttonAdd" type="textarea" v-model="form.description"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="8" :offset="0">

            <el-row>
              <!-- Transaction ID -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="120px" label="Transaction ID">
                  <strong v-html="form.transactionNo"></strong>
                </el-form-item>
              </el-col>
              <!-- Save Template -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="120px" label="Save template" prop="saveTemplate">
                  <el-switch :disabled="buttonAdd" v-model="form.saveTemplate"></el-switch>
                </el-form-item>
              </el-col>
              <!-- Template Name -->
              <el-col :span="24" :offset="0" v-if="form.saveTemplate">
                <el-tooltip content="If you fill this field, the current JE after Add will be stored as template" placement="top">
                  <el-form-item label-width="120px" label="Template Name" prop="reference">
                    <el-input :disabled="buttonAdd" placeholder="Template Name" v-model="form.reference"></el-input>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <!-- Source Documents -->
              <el-col :span="24" :offset="0">
                <el-form-item label-width="120px" label="Upload / View">
                  <el-button @click="openModalLoadFile" type="primary" size="small" icon="el-icon-upload" style="width: 100%;">Source Documents</el-button>
                </el-form-item>
              </el-col>
            </el-row>

          </el-col>
        </el-row>

        <!--Table-->
        <el-table
          size="mini"
          border
          max-height="200"
          :data="form.items"
          style="width: 1336px"
          :cell-class-name="cellClassName"
          @cell-click="cellClick">
          <el-table-column
            fixed
            label="Account Code"
            width="120">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }"
                :prop="'items.' + scope.$index + '.code'">
                <el-select :disabled="buttonAdd" style="width:100%" v-model="scope.row.code" filterable @remove-tag="removeTag" placeholder="Gl Accounts">

                  <el-option v-for="item in companyAccountList"
                    :disabled="item.isParent"
                    :key="item.id"
                    :label="item.code"
                    :value="item.code"
                    @click.native="selectItemCode(item, scope.row)">
                  </el-option>

                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="Name"
            width="160">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }"
                :prop="'items.' + scope.$index + '.name'">
                <el-select :disabled="buttonAdd" style="width:100%" v-model="scope.row.name" filterable @remove-tag="removeTag" placeholder="Gl Accounts">

                  <el-option v-for="item in companyAccountList"
                    :disabled="item.isParent"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                    @click.native="selectItemName(item, scope.row)">
                  </el-option>

                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="Debit"
            align="center"
            width="100">
            <template slot-scope="scope">
              <!-- <div v-if="!showInfo">{{ formatPriceLong(scope.row.debit) }}</div> -->
              <!-- <money v-if="!showInfo" v-model="scope.row.debit" :readonly="buttonAdd" v-bind="moneyLong" @change.native="debitHandler(scope.row)" style="text-align: center;"></money> -->
              <money v-model="scope.row.debit" :readonly="buttonAdd" v-bind="money" @change.native="debitHandler(scope.row)" style="text-align: center;"></money>
              <!--<el-input placeholder="Debit" v-model="scope.row.debit"></el-input>-->
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="Credit"
            align="center"
            width="100">
            <template slot-scope="scope">
              <!-- <div v-if="!showInfo">{{ formatPriceLong(scope.row.credit) }}</div> -->
              <!-- <money v-if="!showInfo" v-model="scope.row.credit" :readonly="buttonAdd" v-bind="moneyLong" @change.native="creditHandler(scope.row)" style="text-align: center;"></money> -->
              <money v-model="scope.row.credit" :readonly="buttonAdd" v-bind="money" @change.native="creditHandler(scope.row)" style="text-align: center;"></money>
              <!--<el-input placeholder="Credit" v-model="scope.row.credit"></el-input>-->
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="Tax Code"
            width="80">
            <template slot-scope="scope">
              <div v-if="form.tax === 4">
                <el-select
                  :disabled="(!scope.row.id && !scope.row.code) || (form.tax == 1) || buttonAdd"
                  v-model="scope.row.taxRate"
                  @change="changeTable()"
                  size="mini"
                  placeholder="Tax"
                  filterable>
                  <el-option-group
                  v-for="group in taxRateListForTaxExempt"
                  :key="group.label"
                  :label="group.label">
                    <el-option v-for="item in group.options"
                      v-show="!item.noTax"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div v-else>
                <el-select
                  :disabled="(!scope.row.id && !scope.row.code) || (form.tax == 1) || buttonAdd"
                  v-model="scope.row.taxRate"
                  @change="changeTable()"
                  size="mini"
                  placeholder="Tax"
                  filterable>
                  <el-option-group
                  v-for="group in taxRateList"
                  :key="group.label"
                  :label="group.label">
                    <el-option v-for="item in group.options"
                      v-show="!item.noTax"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="Tax Amount"
            width="100">
            <template slot-scope="scope">
              <money v-model="scope.row.taxAmount" v-bind="money" :readonly="true" style="text-align: center;"></money>
              <!-- <el-input disabled placeholder="" v-model="scope.row.taxAmount" size="mini"></el-input> -->
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Details">
            <template slot-scope="scope">
              <el-input :disabled="buttonAdd" placeholder="Details" v-model="scope.row.description" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="Allocated To"
            align="center"
            width="100">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :prop="'items.' + scope.$index + '.entityTypeId'"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
                <el-select
                    :disabled="(!scope.row.id && !scope.row.code) || buttonAdd"
                    v-model="scope.row.entityTypeId"
                    size="mini"
                    placeholder="Type"
                    @change="selectEntityType(scope)">
                  <el-option
                      v-for="item in entityTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="item.disabled">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="BU"
            align="center">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :prop="'items.' + scope.$index + '.buId'"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
                <el-select
                    v-model="scope.row.buId"
                    :disabled="!scope.row.entityTypeId || buttonAdd"
                    size="mini"
                    placeholder="BU"
                    @change="selectBu(scope)">
                  <el-option
                      v-for="item in scope.row.buList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <!-- :prop="'items.' + scope.$index + '.parentId'"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }" -->
          <el-table-column
            label="WHS-ENG-PRO"
            align="center"
            width="150">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                v-if="scope.row.entityTypeId !== 2">
                <el-select
                    v-model="scope.row.parentId"
                    :disabled="!scope.row.buId || buttonAdd"
                    size="mini"
                    placeholder="WHS-ENG-PRO"
                    @change="selectParent(scope)">
                  <el-option
                      v-for="item in scope.row.parentList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="Task"
            align="center">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :prop="'items.' + scope.$index + '.taskId'">
                <el-select
                    v-model="scope.row.taskId"
                    :disabled="!scope.row.taskList.length || buttonAdd"
                    size="mini"
                    placeholder="Task"
                    @change="selectTask(scope)">
                  <el-option
                      v-for="item in scope.row.taskList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="EU"
            align="center">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :prop="'items.' + scope.$index + '.userId'">
                <el-select
                    v-model="scope.row.userId"
                    :disabled="!scope.row.taskId || buttonAdd"
                    size="mini"
                    placeholder="EU"
                    @change="selectEU(scope)">
                  <el-option
                    v-for="item in scope.row.userList"
                    :key="item.userId"
                    :label="item.userFullName"
                    :next-icon="false"
                    :value="item.userId">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="Client or Vendor"
            align="center"
            width="150">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :prop="'items.' + scope.$index + '.vendorClientTypeId'">
                <el-select
                    :disabled="(!scope.row.userId && !scope.row.buId) || buttonAdd"
                    v-model="scope.row.vendorClientTypeId"
                    size="mini"
                    placeholder="Select"
                    @change="selectVendorClientType(scope)">
                  <el-option
                      v-for="item in vendorClientList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="Client / Vendor"
            align="center"
            width="150">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                v-if="form.items[scope.$index].vendorClientTypeId === 'vendor'"
                :prop="'items.' + scope.$index + '.vendorId'">
                <el-select
                    :disabled="!scope.row.vendorClientTypeId || buttonAdd"
                    v-model="scope.row.vendorId"
                    size="mini"
                    filterable
                    placeholder="Vendor">
                  <el-option
                      v-for="item in scope.row.vendorList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom:0;"
                v-else
                :prop="'items.' + scope.$index + '.clientId'">
                <el-select
                    :disabled="!scope.row.vendorClientTypeId || buttonAdd"
                    v-model="scope.row.clientId"
                    size="mini"
                    filterable
                    placeholder="Client">
                  <el-option
                      v-for="item in scope.row.clientList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="Operations"
            align="left"
            width="170">
            <template slot-scope="scope">
              <div>
                <el-button
                  v-if="scope.$index !== 0"
                  :disabled="buttonAdd"
                  size="mini"
                  type="primary"
                  plain
                  @click="addNewItem(scope.$index, scope.row)">Add line</el-button>
                <el-button
                  v-if="(scope.$index !== 0) && (scope.$index !== 1)"
                  :disabled="buttonAdd"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  plain
                  @click="removeItem(scope.$index, scope.row)"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!--Table bottom-->
        <el-table size="mini"
          border
          :show-header="false"
          :data="[form.totals]"
          style="width: 100%; margin-top: -1px;">
          <el-table-column
            width="280"
            align="right">
            Total
          </el-table-column>
          <el-table-column
            align="center"
            width="100">
            <template slot-scope="scope">
              <span style="margin-left: -16px;">{{formatPrice(scope.row.debit = countTotalDebit(form.items))}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="100">
            <template slot-scope="scope">
              <span style="margin-left: -16px;">{{formatPrice(scope.row.credit = countTotalCredit(form.items))}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="80">
          </el-table-column>
          <el-table-column
            align="center"
            width="100">
            <template slot-scope="scope">
              <span style="margin-left: -16px;">{{formatPrice(scope.row.tax = countTotalTax(form.items))}}</span>
            </template>
          </el-table-column>
          <el-table-column>
          </el-table-column>
        </el-table>

        <!-- Out of Balance -->
        <el-row :span="24" style="margin-top: 10px;">
          <el-form-item label-width="282px" label="Out of Balance" prop="description">
            <div style="margin-left: 85px;" :class="{'text-danger' : form.totals.credit - form.totals.debit === 0 ? false : true}">
              {{formatPrice(form.totals.credit - form.totals.debit)}}
            </div>
          </el-form-item>
        </el-row>

        <!-- Created By -->
        <el-row :gutter="20" style="margin-top: 20px;">
          <el-col :span="12" :offset="0">
            Created By: <b>{{form.createdBy}}</b>
          </el-col>
          <el-col :span="12" :offset="0"></el-col>
        </el-row>

        <!-- Button -->
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="8" :offset="0">
            <el-button v-if="companyLayout.permission.historyAccountThinkJournals" @click="openModalHistiry" :disabled="!companyLayout.permission.viewTransactionInJournalHistory" type="primary" plain size="medium">History</el-button>
            <el-button v-if="(showInfo && (form.entryType !== 'OPENING')) && companyLayout.permission.reverseAccountThinkJournals" @click="reverseTransaction()" :disabled="status != 'Recorded'" type="primary" plain size="medium">Reverse</el-button>
            <el-button v-if="(showInfo && (form.entryType !== 'OPENING')) && companyLayout.permission.reverseAccountThinkJournals" @click="openModalReverseByDateTransaction()" :disabled="status != 'Recorded'" type="primary" plain size="medium">Reverse by date</el-button>
          </el-col>
          <el-col :span="16" :offset="0">
            <el-form-item style="display: flex; justify-content: flex-end;" v-if="showInfo && (form.entryType !== 'OPENING')">
              <!-- <el-button disabled class="modal__btn" type="primary" plain size="medium">Add + Save as Template</el-button> -->
              <!-- <el-button disabled class="modal__btn" type="primary" plain size="medium">Add</el-button> -->
              <el-button v-if="buttonAdd && companyLayout.permission.editAccountThinkJournals" :disabled="status != 'Added'" @click="buttonAddChange()" class="modal__btn" type="primary" plain size="medium">Edit</el-button>
              <el-button v-else @click="editJournalEntrySubmit('form')" class="modal__btn" type="primary" plain size="medium">Save Changes</el-button>
              <el-button v-if="companyLayout" @click="checkedTransaction()" :disabled="status != 'Added'" class="modal__btn" type="primary" plain size="medium">Checked</el-button>
              <el-button v-if="companyLayout" @click="sendToAccountant()" :disabled="status != 'Checked' || !this.isAccountantCompanyUsers" class="modal__btn" type="primary" plain size="medium">Send to Accountant</el-button>
              <el-button v-if="companyLayout" @click="voidTransaction()" :disabled="this.status === 'Voided' || this.status === 'Reversed'" class="modal__btn" type="primary" plain size="medium">{{this.status === 'Recorded' ? 'Voided' : 'Delete'}}</el-button>
              <el-button v-if="allowOnlyAccountantsCompanyUser" @click="recordTransaction()" :disabled="status != 'Checked' || !this.isAccountantCompanyUsers" class="modal__btn" type="primary" plain size="medium">Record</el-button>
              <el-button v-else @click="recordTransaction()" :disabled="status != 'Checked'" class="modal__btn" type="primary" plain size="medium">Record</el-button>
            </el-form-item>
            <span v-if="form.entryType === 'OPENING'">For viewing only. To edit data for this type of transactions, proceed to the Opening Balances Addition form.</span>
          </el-col>
        </el-row>

      </el-form>
    </sweet-modal>

    <sweet-modal width="500" blocking title="Reverse by date" ref="modalReverseByDate" class="modal" v-on:close="closeModalReverseByDate">
      <el-date-picker
        v-model="reverseByDate"
        value-format="timestamp"
        type="datetime"
        :picker-options="pickerOptions"
        placeholder="Select date and time">
      </el-date-picker>
      <div style="margin-top: 20px; display: flex; justify-content: flex-end;">
        <el-button :disabled="!reverseByDate" @click="reverseByDateTransaction()" type="primary" plain size="medium">Save</el-button>
      </div>
    </sweet-modal>

    <!-- Modal Load File -->
    <sweet-modal width="500" blocking title="Source Documents 1" ref="openModalLoadFileEdit" class="modal">
      <el-button :disabled="status != 'Added' || buttonAdd" @click="$refs.fileJEEdit.click()"  icon="el-icon-upload" style="width: 100%; margin-bottom: 20px;">
        {{$t('modal_documentManagment_sop_uploadFile')}}
      </el-button>
      <input type="file" ref="fileJEEdit" @change="handleFile" style="display:none;"/>

      <!-- <label for="fileJEEdit" class="file">
        <i class="el-icon-upload"></i>
          {{$t('modal_documentManagment_sop_uploadFile')}}
      </label>
      <input class="file" ref='file' v-show="true" @change="handleFile" id="fileJEEdit" name="myFile" type="file"> -->

      <div v-for="list in this.form.fileArr" :key="list.id" class="file__item">
        <div v-if="list.url" class="file__item__viewed">
            <span @click="viewFile(list.url)">
                <i class="el-icon-view pointer"  style="margin-right:10px;"></i>
                <span class="file__name pointer">{{list.name}}</span>
            </span>
            <div v-if="(status == 'Added') && !buttonAdd" class="file__delete pointer" @click="deleteFile(list, 'edit')"><i class="el-icon-close"></i></div>
        </div>
        <div v-else class="file__item__not-loaded">
            <div class="file__name">{{list.name}}</div>
            <div v-if="(status == 'Added') && !buttonAdd" class="file__delete pointer" @click="deleteFile(list, 'edit')"><i class="el-icon-close"></i></div>
        </div>
      </div>
    </sweet-modal>

    <!-- Modal History -->
    <modal-history :historyList='historyList' ref="openHistory"></modal-history>

    <!--VIEWER-->
    <div v-if="viewerType == 1">
        <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
            <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
        </sweet-modal>
    </div>
    <div v-if="viewerType == 2">
        <div v-show="false" class="images" v-viewer="{movable: true}">
            <img :src="fileUrl" :key="fileUrl" />
        </div>
    </div>
    <div class="mod" v-if="viewerType == 3">
        <div @click="closeMod" class="mod__close">
            <span>x</span>
        </div>
        <Media
                :kind="'video'"
                :controls="true"
                :src="fileUrl"
        >
        </Media>
    </div>
    <div class="mod" v-if="viewerType == 4">
        <div @click="closeMod" class="mod__close">
            <span>x</span>
        </div>
        <Media
                :kind="'audio'"
                :controls="true"
                :src="fileUrl"
        >
        </Media>
    </div>

  </div>
</template>

<script>
  import Media from '@dongido/vue-viaudio'
  import axios from 'axios'
  import {Money} from 'v-money'
  let moment = require('moment');
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import modalHistory from './historyJournalEntry.vue'
  const FASTFOREX_API_KEY = process.env.VUE_APP_FASTFOREX_API_KEY

  export default {
    name: "editJournalEntryModal",
    components:{
      SweetModal,
      Money,
      Media,
      modalHistory,
    },
    props: {
      showInfo: {
        type: Boolean,
        default: true
      },
      tab: {
        type: String,
        default: 'general'
      },
    },
    data() {
      return{
        viewerType: 0,
        fileUrl: '',

        moment:moment,

        reverseByDate: null,

        status: 'Added',

        historyList: [],

        taxList: [
          {id: 1, name: 'No Tax'},
          {id: 2, name: 'Excluding Tax'},
          {id: 3, name: 'Including Tax'},
          {id: 4, name: 'Tax Exempt'},
        ],
        entryTypeList: [
          {id: 1, name: 'GENERAL'},
          {id: 4, name: 'LIQUIDATION'},
          {id: 5, name: 'CASHADVANCE'},
          {id: 0, name: 'ADJUSTING'},
          // {id: 2, name: 'OPENING'},
          {id: 3, name: 'CLOSING'},
        ],
        entityTypeList: [
          { id: 2, name: 'Business Unit' },
          { id: 4, name: 'Warehouse', disabled: true },
          { id: 3, name: 'Engagement' },
          { id: 1, name: 'Project' },
        ],
        vendorClientList: [
          { id: 'vendor', name: 'Vendor' },
          { id: 'client', name: 'Client' }
        ],
        companyAccountList: [],

        money: {
          precision: 2,
          decimal: '.',
          thousands: ',',
          masked: false
        },

        moneyLong: {
          precision: 6,
          decimal: '.',
          thousands: ',',
          masked: false
        },

        moneyRate: {
          precision: 5,
          decimal: '.',
          thousands: ',',
          masked: false
        },

        glAccountsList: [],
        currencyList: [],
        currencyCompany: {},
        taxRateList: [],
        taxRateListForTaxExempt: [],
        taxRateListAll: [],
        taxRateListOutput: [],

        row: null,
        buttonAdd: true,

        isAccountantCompanyUsers: true,
        allowOnlyAccountantsCompanyUser: true,

        form:{
          saveTemplate: false,

          // left
          entryType: 'GENERAL',
          // journalDate: moment().format("MM-DD-YYYY"),
          journalDate: moment().format("MM-DD-YYYY"),
          currencyName: null,
          exchangeRate: 1.00,
          recorderDate: null,

          // right
          transactionNo: null,
          documentDate: null,
          sourceRef: null,
          reference: null,
          tax: 1,

          fileArr: [],

          description: '',

          includeTaxRegister: false,
          glAccounts:null,
          sendToAccountant: false,
          totals: {
            debit: 0,
            credit: 0,
            tax: 0,
          },
          createdBy: '',
          items: []
        },
        pickerOptions: {
          disabledDate: this.disabledDate,
        },
        rules:{
          journalDate: [
            { required: true, message: 'Please pick a journal date', trigger: 'blur' }
          ],
          documentDate: [
            { required: true, message: 'Please pick a document date', trigger: 'blur' }
          ],
          reference: [
            { required: true, message: 'Please pick a reference', trigger: 'blur' }
          ],
          currencyName: [
            { required: true, message: 'Please pick a currency', trigger: 'blur' }
          ],
          sourceRef: [
            { required: true, message: 'Please pick a source reference', trigger: 'blur' }
          ],
          recorderDate: [
            { required: true, message: 'Please pick a event date', trigger: 'blur' }
          ],
          exchangeRate: [
            { required: true, message: 'Please pick a exchange rate', trigger: 'blur' }
          ],
          // TODO: del
          // glAccounts: [
          //   { required: true, message: 'Please select an accounts', trigger: 'blur' }
          // ],
        }
      }
    },
    watch:{
      // checked: function (val) {
      //   val ? this.money.precision = 6 : this.money.precision = 2
      // },
      'form.journalDate': function (val) {
        if (this.currencyCompany.code == this.form.currencyName) {
          this.form.exchangeRate = 1
        } else {

          if (moment(new Date()).format("YYYY-MM-DD") == moment(this.form.journalDate, 'MM-DD-YYYY').format("YYYY-MM-DD")) {
            console.log(`[FastForex Request] URL: https://api.fastforex.io/fetch-one?from=${this.form.currencyName}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`);
            new Promise((resolve) => {
              resolve({
                data: {
                  result: {
                    [this.currencyCompany.code]: 1
                  }
                }
              })
            })
            .then(response => {
              this.form.exchangeRate = response.data.result[this.currencyCompany.code]
              // eslint-disable-next-line no-console
              console.log('response', response.data.results)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
          } else if (moment(this.form.journalDate, 'MM-DD-YYYY').format("x") > moment(new Date()).format("x")) {
            this.form.exchangeRate = 1
          } else {
            console.log(`[FastForex Historical Request] URL: https://api.fastforex.io/historical?date=${ moment(this.form.journalDate, 'MM-DD-YYYY').format("YYYY-MM-DD") }&from=${this.form.currencyName}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`);
            new Promise((resolve) => {
              resolve({
                data: {
                  results: {
                    [this.currencyCompany.code]: 1
                  }
                }
              })
            })
            .then(response => {
              this.form.exchangeRate = response.data.results[this.currencyCompany.code]
              // eslint-disable-next-line no-console
              console.log('response', response.data.results)
            })
            .catch(error => {
              if (error.response && error.response.data && error.response.data.error === 'Historical data limited to 150 days') {
                this.notification("Notification", error.response.data.error, "info")
              }
              console.log('An error occurred:', error);
            });
          }

        }
      }
    },
    computed:{
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
      user() {
        return this.$store.state.user
      },
      totalForRate() {
        return this.formatPrice(this.form.exchangeRate * this.countTotalDebit(this.form.items))
      },
      salesTaxListNoTaxSP() {
        return this.taxRateListOutput.find(tax => tax.noTaxSP)
      },
    },
    methods:{
      openModalLoadFile() {
        this.$refs.openModalLoadFileEdit.open()
      },
      handleFile(e) {
        console.log('---', e.target.files[0]);
        let file = e.target.files[0];
        this.form.fileArr.push(e.target.files[0]);
        console.log('---fileList', this.form.fileArr);
        this.$refs.fileJEEdit.value = ''
      },
      deleteFile(file, type) {
        let index = this.form.fileArr.indexOf(file);
        if (index !== -1) {
          this.form.fileArr.splice(index, 1);
        }
      },
      viewFile(url){
        let type = url.split('.').pop().toUpperCase()
        if (type == 'GIF' || type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF' || type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX') {
          this.fileUrl = url;
          this.type = this.fileUrl.split('.').pop().toUpperCase();
          console.log('---', this.fileUrl, this.type);

          if (type == 'GIF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (type == 'OGG' || type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl;
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl;
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }else if (type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX'){
            const win = window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.fileUrl}`, '_blank');
            win.focus();
          }
        }
      },
      changeCurrency(item) {
        if (this.currencyCompany.id == item.id || this.currencyCompany.code == item.code) {
          this.form.exchangeRate = 1
        } else {
          if (moment(new Date()).format("YYYY-MM-DD") == moment(this.form.journalDate, 'MM-DD-YYYY').format("YYYY-MM-DD")) {
            console.log(`[FastForex Request] URL: https://api.fastforex.io/fetch-one?from=${item.code}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`);
            new Promise((resolve) => {
              resolve({
                data: {
                  result: {
                    [this.currencyCompany.code]: 1
                  }
                }
              })
            })
            .then(response => {
              this.form.exchangeRate = response.data.result[this.currencyCompany.code]
              // eslint-disable-next-line no-console
              console.log('response', response.data.results)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
          } else if (moment(this.form.journalDate, 'MM-DD-YYYY').format("x") > moment(new Date()).format("x")) {
            this.form.exchangeRate = 1
          } else {
            new Promise((resolve) => {
              resolve({
                data: {
                  results: {
                    [this.currencyCompany.code]: 1
                  }
                }
              })
            })
            .then(response => {
              this.form.exchangeRate = response.data.results[this.currencyCompany.code]
              // eslint-disable-next-line no-console
              console.log('response', response.data.results)
            })
            .catch(error => {
              if (error.response && error.response.data && error.response.data.error === 'Historical data limited to 150 days') {
                this.notification("Notification", error.response.data.error, "info")
              }
              console.log('An error occurred:', error);
            });
          }
        }
      },
      // open modal Journal Entry
      async openModalFromJournalEntry(row){
        this.row = row
        this.status = row.status
        let loader = this.$loading.show();
        try {
          await this.getDirectory();
          await this.getCompanyAccountList()
          await this.getCurrencyList()
          await this.getTaxRateList()
          await this.getItem(row.id)
          await this.$refs.createJournalEntry.open()
          loader.hide()
        }catch (err){
          console.log(err)
          loader.hide()
        }
      },
      getDirectory(stateProjectId, id){
        return new Promise((resolve, reject) =>{
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/journalEntry/directory?companyId=${this.$route.query.companyId}`)
            .then(response => {
              this.glAccountsList = response.data.list
              // this.currencyList = response.data.currencyList
              this.form.currencyName = response.data.currencyList[0].code
              this.currencyCompany.id = response.data.currencyList[0].id
              this.currencyCompany.code = response.data.currencyList[0].code
              this.currencyCompany.name = response.data.currencyList[0].name

              this.isAccountantCompanyUsers = response.data.isAccountantCompanyUsers
              this.allowOnlyAccountantsCompanyUser = response.data.allowOnlyAccountantsCompanyUser

              resolve(response.data);
              console.log(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      getCompanyAccountList() {
        return new Promise((resolve, reject) =>{
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/account/company-account/list?companyId=${this.$route.query.companyId}`)
            .then(response => {
              this.companyAccountList = response.data.list
              resolve(response.data);
              console.log(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      getCurrencyList() {
        return new Promise((resolve, reject) =>{
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=create`)
            .then(response => {
              this.currencyList = response.data.currencyList
              resolve(response.data);
              console.log(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      getTaxRateList() {
        return new Promise((resolve, reject) =>{
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/account/accountOnlyTax?companyId=${this.$route.query.companyId}`)
            .then(response => {

              let input = {
                label: 'Input',
                options: response.data.list.input
              }
              let output = {
                label: 'Output',
                options: response.data.list.output
              }

              this.taxRateList.push(input, output)

              // input
              let inputSalesTaxListExemptTax = response.data.list.input.find(tax => tax.exemptTax)
              let inputSalesTaxListWithZeroRate = response.data.list.input.find(tax => tax.zeroTax)
              let inputSalesTaxListNoTax = response.data.list.input.find(tax => tax.noTax)

              // output
              let outputSalesTaxListExemptTax = response.data.list.output.find(tax => tax.exemptTax)
              let outputSalesTaxListWithZeroRate = response.data.list.output.find(tax => tax.zeroTax)
              let outputSalesTaxListNoTax = response.data.list.output.find(tax => tax.noTax)
              console.log("🚀 ~ returnnewPromise ~ outputSalesTaxListNoTax:", outputSalesTaxListNoTax)

              let inputForTaxExempt = {
                label: 'Input',
                options: [inputSalesTaxListExemptTax, inputSalesTaxListWithZeroRate, inputSalesTaxListNoTax]
              }
              let outputForTaxExempt = {
                label: 'Output',
                options: [outputSalesTaxListExemptTax, outputSalesTaxListWithZeroRate, outputSalesTaxListNoTax]
              }

              this.taxRateListForTaxExempt.push(inputForTaxExempt, outputForTaxExempt)

              for (let key in response.data.list) {
                response.data.list[key].forEach(item => this.taxRateListAll.push(item))
              }

              this.taxRateListOutput = response.data.list.output

              resolve(response.data);
              console.log(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      getItem(transactionId) {
        return new Promise((resolve, reject) =>{
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/accountTransaction/JournalItem?transactionId=${transactionId}`)
            .then(response => {

              // TODO:
              // eslint-disable-next-line no-console
              console.log('JournalItem', response)
              // left
              this.form.entryType = response.data.data.entryTypeName
              this.form.journalDate = moment(response.data.data.journalDate).format("MM-DD-YYYY")
              this.form.currencyName = response.data.data.foreignCurrency === 'null' ? response.data.data.transactionCurrency : response.data.data.foreignCurrency
              this.form.exchangeRate = response.data.data.exchangeRate
              this.form.recorderDate = moment(response.data.data.recorderDate).format("MM-DD-YYYY")

              // right
              this.form.transactionNo = response.data.data.transactionNo
              this.form.documentDate = response.data.data.documentDate
              this.form.sourceRef = response.data.data.sourceRef
              this.form.reference = response.data.data.referenceTag
              this.form.saveTemplate = response.data.data.referenceTag ? true : false
              this.form.tax = response.data.data.taxTypeId

              this.form.description = response.data.data.transactionDescription

              this.form.fileArr = response.data.data.files

              for (let k = 0; k < this.form.fileArr.length; k++) {
                this.form.fileArr[k].name = this.form.fileArr[k].originalName
              }

              let list = response.data.data.journalList
              // this.form.items = response.data.data.journalList

              for (let i = 0; i < list.length; i++) {
                // NTS-0% No Tax Sales
                if (this.form.tax === 1) list[i].taxRate = this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null

                list[i].vendorList = []
                list[i].vendorList = []
                list[i].clientList = []
                list[i].buList = []
                list[i].parentList = []
                list[i].taskList = []
                list[i].userList = []

                // Allocated To
                if (list[i].entityTypeId) {
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                    .post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
                    .then(response => {
                      list[i].buList = response.data.list
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                      reject(error)
                    });
                }

                // BU
                if (list[i].buId) {
                  switch (list[i].entityTypeId) {
                    case 1:
                      axios.get(`/api/v1/businessUnits/projectsListBU?businessUnitId=${list[i].buId}`).then(response => {
                        console.log('---', response.data)
                        list[i].parentList = response.data.list
                      }).catch(err => {
                        console.log(err)
                      })
                      break;
                    case 2:
                      axios.post(`/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${list[i].buId}`).then(response => {
                        console.log('---', response.data)
                        const list = response.data.newList
                        list.shift()
                        list[i].taskList = list
                      }).catch(err => {
                        console.log(err)
                      })
                      break;
                    case 3:
                      axios.get(`/api/v1/businessUnits/engagementsListBU?businessUnitId=${list[i].buId}`).then(response => {
                        console.log('---', response.data)
                        list[i].parentList = response.data.list
                      }).catch(err => {
                        console.log(err)
                      })
                      break
                  }
                }

                // WHS-ENG-PRO
                if (list[i].parentId) {
                  let url = ''
                  switch (list[i].entityTypeId) {
                    case  1:
                      url = `/api/v1/projectTasks/list?companyId=${this.$route.query.companyId}&projectId=${list[i].parentId}`
                      break;
                    case 2:
                      url = `/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${list[i].parentId}`
                      break;
                    case 3:
                      url = `/api/v1/engagementTasks/list?companyId=${this.$route.query.companyId}&engagementId=${list[i].parentId}`
                      break
                  }

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                    .post(url)
                    .then(response => {
                      const arr = response.data.newList ? response.data.newList : response.data.newlist
                      arr.shift()
                      list[i].taskList = arr
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                      reject(error)
                    });
                }

                // Task
                if (list[i].taskId) {
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  switch (list[i].entityTypeId) {
                    case 1:
                      axios.post(`/api/v1/projectTasks/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${list[i].parentId}&projectTaskId=${list[i].taskId}`).then(response => {
                        list[i].userList = response.data.extendedInfo.projectTaskCompanyUserList
                      }).catch(err => {
                        console.log(err)
                      })
                      break;
                    case 2:
                      axios.post(`/api/v1/businessUnitTasks/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${list[i].buId}&businessUnitTaskId=${list[i].taskId}`).then(response => {
                        list[i].userList = response.data.extendedInfo.businessUnitTaskCompanyUserList
                      }).catch(err => {
                        console.log(err)
                      })
                      break;
                    case 3:
                      axios.post(`/api/v1/engagementTasks/extendedInfo?companyId=${this.$route.query.companyId}&engagementId=${list[i].parentId}&engagementTaskId=${list[i].taskId}`).then(response => {
                        list[i].userList = response.data.extendedInfo.engagementTaskCompanyUserList
                      }).catch(err => {
                        console.log(err)
                      })
                      break;
                  }
                }

                // Vendor
                if (list[i].vendorId) {
                  list[i].vendorClientTypeId = 'vendor'

                  let currencyId = null
                  for (let i = 0; i < this.currencyList.length; i++) {
                    if (this.currencyList[i].code == this.form.currencyName) {
                      currencyId = this.currencyList[i].id
                    }
                  }

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.get(`/api/v1/client-vendor/list?type=vendor&companyId=${this.$route.query.companyId}&currencyId=${currencyId}`)
                    .then(response => {
                      list[i].vendorList = response.data.list
                    }).catch(err => {
                      console.log(err)
                    })
                }

                // Client
                if (list[i].clientId) {
                  list[i].vendorClientTypeId = 'client'

                  let currencyId = null
                  for (let i = 0; i < this.currencyList.length; i++) {
                    if (this.currencyList[i].code == this.form.currencyName) {
                      currencyId = this.currencyList[i].id
                    }
                  }

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.get(`/api/v1/client-vendor/list?type=client&companyId=${this.$route.query.companyId}&currencyId=${currencyId}`)
                    .then(response => {
                      list[i].clientList = response.data.list
                    }).catch(err => {
                      console.log(err)
                    })
                }

              }

              this.form.items = list

              this.form.createdBy = response.data.data.createdBy
              resolve(response.data);
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      selectItemCode(item, row){
        if (item.code === '1.1.1.1' || item.code === '1.1.1.2') return
        // const findId = (element) => element.id === item.id;

        // if(this.form.items.some(findId)){
        //   row.id = null;
        //   row.code = null;
        //   row.name = null;
        //   row.debit = 0;
        //   row.credit = 0;
        //   row.taxRate = null;
        //   row.taxAmount = 0;
        //   row.description = '';
        //   row.entityTypeId = null;
        //   row.buId = null;
        //   row.parentId = null;
        //   row.taskId = null;
        //   row.userId = null;
        //   row.vendorClientTypeId = null;
        //   row.vendorId = null;
        //   row.clientId = null;
        //   // lists
        //   row.vendorList = [];
        //   row.clientList = [];
        //   row.buList = [];
        //   row.parentList = [];
        //   row.taskList = [];
        //   row.userList = [];
        //   return
        // }

        row.name = item.name;
        row.id = item.id;
        if (this.form.tax != 1) {
          row.taxRate = item.assignToTaxAccountId
        } else {
          // NTS-0% No Tax Sales
          row.taxRate = this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null
        }
        this.changeTable()
        return row
      },
      selectItemName(item, row){
        if (item.code === '1.1.1.1' || item.code === '1.1.1.2') return
        // const findId = (element) => element.id === item.id;

        // if(this.form.items.some(findId)){
        //   row.id = null;
        //   row.code = null;
        //   row.name = null;
        //   row.debit = 0;
        //   row.credit = 0;
        //   row.taxRate = null;
        //   row.taxAmount = 0;
        //   row.description = '';
        //   row.entityTypeId = null;
        //   row.buId = null;
        //   row.parentId = null;
        //   row.taskId = null;
        //   row.userId = null;
        //   row.vendorClientTypeId = null;
        //   row.vendorId = null;
        //   row.clientId = null;
        //   // lists
        //   row.vendorList = [];
        //   row.clientList = [];
        //   row.buList = [];
        //   row.parentList = [];
        //   row.taskList = [];
        //   row.userList = [];
        //   return
        // }

        row.code = item.code;
        row.id = item.id;
        if (this.form.tax != 1) {
          row.taxRate = item.assignToTaxAccountId
        } else {
          // NTS-0% No Tax Sales
          row.taxRate = this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null
        }
        this.changeTable()
        return row
      },
      debitHandler(row){
        console.log('debit hanler', row)
        if(row.debit){
          row.credit = 0;
        }
        this.changeTable()
      },
      creditHandler(row){
        if(row.credit){
          row.debit = 0;
        }
        this.changeTable()
      },
      countTotalDebit(items){
        if(items.length){
          if (this.form.tax == 2) {
            return (items.reduce((acc, item) => acc + (item.debit ? item.debit + item.taxAmount : 0), 0) || 0).toFixed(2);
          } else {
            return (items.reduce((acc, item) => acc + item.debit, 0) || 0).toFixed(2);
          }
        }else{
          return 0
        }
      },
      countTotalCredit(items){
        if(items.length){
          if (this.form.tax == 2) {
            return (items.reduce((acc, item) => acc + (item.credit ? item.credit + item.taxAmount : 0), 0) || 0).toFixed(2);
          } else {
            return (items.reduce((acc, item) => acc + item.credit, 0) || 0).toFixed(2);
          }
          // return items.reduce((acc, item) => acc + item.credit, 0) || 0;
        }else{
          return 0
        }
      },
      countTotalTax(items){
        if(items.length){
          return items.reduce((acc, item) => acc + item.taxAmount, 0) || 0;
        }else{
          return 0
        }
      },
      removeItem(index, row){
        this.removeTag(row.id)
      },
      addNewItem(index, row){
        const itm = {
          id: null,
          code:null,
          name:null,
          debit: 0,
          credit: 0,
          taxRate: null,
          taxAmount: 0,
          description: '',
          entityTypeId: null,
          buId: null,
          vendorClientTypeId: null,
          vendorId: null,
          clientId: null,
          // lists
          vendorList: [],
          clientList: [],
          buList: [],
          parentList: [],
          taskList: [],
          userList: [],
        };

        this.form.items.push(itm)
        return row
      },
      removeTag(id){
        console.log(id)
        for (let i = 0; i < this.form.items.length; i++){
          if(this.form.items[i].id === id){
            this.form.items.splice(i, 1);
            return
          }
        }
      },
      countTotalAmount(items){
        const results = []
        for (let i = 0; i < items.length; i++) {
          results.push(items[i].countTotals)
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });
          console.log('res', result)
          return result
        }
      },
      async selectEntityType(scope) {
        const loader = this.$loading.show();
        try {
          scope.row.buId = null
          scope.row.parentId = null
          scope.row.taskId = null
          scope.row.userId = null
          scope.row.vendorClientTypeId = null
          scope.row.vendorId = null
          scope.row.clientId = null
          scope.row.buList = []
          scope.row.parentList = []
          scope.row.taskList = []
          scope.row.userList = []
          scope.row.vendorList = []
          scope.row.clientList = []

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();

          const response = await axios.post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
          scope.row.buList = response.data.list

          loader.hide()
        } catch (err) {
          loader.hide()
          console.log(err)
        }
      },
      async selectBu(scope) {
        scope.row.parentId = null
        scope.row.taskId = null
        scope.row.userId = null
        scope.row.vendorClientTypeId = null
        scope.row.vendorId = null
        scope.row.clientId = null
        scope.row.parentList = []
        scope.row.taskList = []
        scope.row.userList = []
        scope.row.vendorList = []
        scope.row.clientList = []

        try {
          const loader = this.$loading.show();
          console.log(scope)
          switch (scope.row.entityTypeId) {
            case 1:
              axios.get(`/api/v1/businessUnits/projectsListBU?businessUnitId=${scope.row.buId}`).then(response => {
                console.log('---', response.data)
                scope.row.parentList = response.data.list
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
            case 2:
              axios.post(`/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId}`).then(response => {
                console.log('---', response.data)
                const list = response.data.newList
                list.shift()
                scope.row.taskList = list
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
            case 3:
              axios.get(`/api/v1/businessUnits/engagementsListBU?businessUnitId=${scope.row.buId}`).then(response => {
                console.log('---', response.data)
                scope.row.parentList = response.data.list
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break
          }
        } catch (err) {
          console.log(err)
        }
      },
      async selectParent(scope) {
        const loader = this.$loading.show();
        try {
          scope.row.vendorClientTypeId = null
          scope.row.vendorId = null
          scope.row.clientId = null
          scope.row.taskId = null
          scope.row.taskList = []
          scope.row.userId = null
          scope.row.userList = []
          scope.row.vendorList = []
          scope.row.clientList = []

          let url = ''
          switch (scope.row.entityTypeId) {
            case  1:
              url = `/api/v1/projectTasks/list?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}`
              break;
            case 2:
              url = `/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.parentId}`
              break;
            case 3:
              url = `/api/v1/engagementTasks/list?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}`
              break
          }

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.post(url)
          loader.hide()
          const list = data.newList ? data.newList : data.newlist
          list.shift()
          scope.row.taskList = list
        } catch (err) {
          loader.hide()
          console.log(err)
        }
      },
      async selectTask(scope) {
        scope.row.vendorClientTypeId = null
        scope.row.vendorId = null
        scope.row.clientId = null
        scope.row.userId = null
        scope.row.userList = []
        scope.row.vendorList = []
        scope.row.clientList = []
        const loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          switch (scope.row.entityTypeId) {
            case 1:
              axios.post(`/api/v1/projectTasks/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}&projectTaskId=${scope.row.taskId}`).then(response => {
                scope.row.userList = response.data.extendedInfo.projectTaskCompanyUserList
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
            case 2:
              axios.post(`/api/v1/businessUnitTasks/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId}&businessUnitTaskId=${scope.row.taskId}`).then(response => {
                scope.row.userList = response.data.extendedInfo.businessUnitTaskCompanyUserList
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
            case 3:
              axios.post(`/api/v1/engagementTasks/extendedInfo?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}&engagementTaskId=${scope.row.taskId}`).then(response => {
                scope.row.userList = response.data.extendedInfo.engagementTaskCompanyUserList
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
          }
        } catch (err) {
          console.log(err)
        }
      },
      selectEU(scope) {
        scope.row.vendorClientTypeId = null
        scope.row.vendorId = null
        scope.row.clientId = null
        scope.row.vendorList = []
        scope.row.clientList = []
      },
      async selectVendorClientType(scope) {
        const loader = this.$loading.show();
        try {
          var currencyId = null
          for (let i = 0; i < this.currencyList.length; i++) {
            if (this.currencyList[i].code == this.form.currencyName) {
              currencyId = this.currencyList[i].id
            }
          }

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();

          switch (scope.row.vendorClientTypeId) {
            case 'vendor':
              axios.get(`/api/v1/client-vendor/list?type=vendor&companyId=${this.$route.query.companyId}&currencyId=${currencyId}`).then(response => {
                scope.row.vendorList = response.data.list
                loader.hide()
              }).catch(err => {
                console.log(err)
                loader.hide()
              })
              break;
            case 'client':
              axios.get(`/api/v1/client-vendor/list?type=client&companyId=${this.$route.query.companyId}&currencyId=${currencyId}`).then(response => {
                scope.row.clientList = response.data.list
                loader.hide()
              }).catch(err => {
                loader.hide()
                console.log(err)
              })
              break;
          }
        } catch (err) {
          loader.hide()
          console.log(err)
        }
      },
      changeTax() {
        this.form.items.forEach((item) => {
          if (item.code) {
            item.taxRate = this.companyAccountList.find(i => i.code === item.code).assignToTaxAccountId
          }
        })
        this.changeTable()
      },
      changeTable(row) {
        switch (this.form.tax) {
          // No Tax
          case 1:
            for (let i = 0; i < this.form.items.length; i++) {
              this.form.items[i].taxRate = this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null
              this.form.items[i].taxAmount = 0
            }
            break;
          // Excluding Tax
          case 2:
            for (let i = 0; i < this.form.items.length; i++) {
              if (this.form.items[i].taxRate && (this.form.items[i].debit || this.form.items[i].credit)) {
                let taxesValue = this.taxRateListAll.find(arr => arr.id === this.form.items[i].taxRate).valueTax
                // this.form.items[i].debit ? (this.form.items[i].taxAmount = (+this.form.items[i].debit * taxesValue) / 100) : (this.form.items[i].taxAmount = (+this.form.items[i].credit * taxesValue) / 100)
                this.form.items[i].debit ? (this.form.items[i].taxAmount = +((+this.form.items[i].debit * +taxesValue) / 100).toFixed(2)) : (this.form.items[i].taxAmount = +((+this.form.items[i].credit * +taxesValue) / 100).toFixed(2))
              } else {
                this.form.items[i].taxAmount = 0
              }
            }
            break;
          // Including Tax
          case 3:
            for (let i = 0; i < this.form.items.length; i++) {
              if (this.form.items[i].taxRate && (this.form.items[i].debit || this.form.items[i].credit)) {
                let taxesValue = this.taxRateListAll.find(arr => arr.id === this.form.items[i].taxRate).valueTax
                // this.form.items[i].debit ? (this.form.items[i].taxAmount = +this.form.items[i].debit - ((+this.form.items[i].debit * 100) / (100 + taxesValue))) : (this.form.items[i].taxAmount = +this.form.items[i].credit - ((+this.form.items[i].credit * 100) / (100 + taxesValue)))
                this.form.items[i].debit ? (this.form.items[i].taxAmount = +(+this.form.items[i].debit - ((+this.form.items[i].debit * 100) / (100 + +taxesValue))).toFixed(2)) : (this.form.items[i].taxAmount = +(+this.form.items[i].credit - ((+this.form.items[i].credit * 100) / (100 + +taxesValue))).toFixed(2))
              } else {
                this.form.items[i].taxAmount = 0
              }
            }
            break;
          // Tax Exempt
          case 4:
            for (let i = 0; i < this.form.items.length; i++) {
              if (this.form.items[i].taxRate && (this.form.items[i].debit || this.form.items[i].credit)) {
                let taxesValue = this.taxRateListAll.find(arr => arr.id === this.form.items[i].taxRate).valueTax
                // this.form.items[i].debit ? (this.form.items[i].taxAmount = +this.form.items[i].debit - ((+this.form.items[i].debit * 100) / (100 + taxesValue))) : (this.form.items[i].taxAmount = +this.form.items[i].credit - ((+this.form.items[i].credit * 100) / (100 + taxesValue)))
                this.form.items[i].debit ? (this.form.items[i].taxAmount = +(+this.form.items[i].debit - ((+this.form.items[i].debit * 100) / (100 + +taxesValue))).toFixed(2)) : (this.form.items[i].taxAmount = +(+this.form.items[i].credit - ((+this.form.items[i].credit * 100) / (100 + +taxesValue))).toFixed(2))
              } else {
                this.form.items[i].taxAmount = 0
              }
            }
            break;
        }
      },
      buttonAddChange() {
        this.buttonAdd = !this.buttonAdd
      },
      editJournalEntrySubmit(form){
        this.$refs[form].validate((valid) => {
          if (valid){
            if(!this.form.totals.credit && !this.form.totals.debit){
              return this.$message({
                type: 'error',
                message: 'Set Debit or Credit'
              })
            }

            for (let i = 0; i < this.form.items.length; i++){
              if(!this.form.items[i].debit && !this.form.items[i].credit){
                return this.$message({
                  type: 'error',
                  message: `Set Debit or Credit in ${this.form.items[i].name}`
                })
              }
            }

            if(this.form.totals.credit === this.form.totals.debit){
              // const data = {
              //   // left
              //   entryTypeName: this.form.entryType,
              //   journalDate: this.form.journalDate,
              //   transactionCurrency: this.currencyCompany.name,
              //   foreignCurrency: this.form.currencyName,
              //   exchangeRate: this.form.exchangeRate,
              //   // TODO: recordedDate

              //   // right
              //   documentDate: this.form.documentDate,
              //   sourceRef: this.form.sourceRef,
              //   referenceTag: this.form.reference,
              //   taxTypeId: this.form.tax,

              //   fileArr: [],

              //   transactionDescription: this.form.description,

              //   journalList: this.form.items,

              // };

              // let items = JSON.stringify(this.form.items)

              let items = this.form.items.map(val => ({
                id: val.id,
                code: val.code,
                name: val.name,
                debit: val.debit,
                credit: val.credit,
                taxRate: val.taxRate,
                taxAmount: val.taxAmount,
                description: val.description,
                entityTypeId: val.entityTypeId,
                buId: val.buId,
                parentId: val.parentId,
                taskId: val.taskId,
                userId: val.userId,
                vendorClientTypeId: val.vendorClientTypeId,
                vendorId: val.vendorId,
                clientId: val.clientId,
                vendorList: val.vendorList,
                clientList: val.clientList,

              }))

              items = JSON.stringify(items)

              let formData = new FormData();
              formData.append('entryTypeName', this.form.entryType)
              formData.append('journalDate', this.form.journalDate)
              formData.append('transactionCurrency', this.currencyCompany.code)
              formData.append('foreignCurrency', this.form.currencyName)
              formData.append('exchangeRate', this.form.exchangeRate)

              formData.append('documentDate', this.form.documentDate)
              formData.append('sourceRef', this.form.sourceRef)
              formData.append('referenceTag', this.form.saveTemplate ? this.form.reference : null)
              formData.append('taxTypeId', this.form.tax)

              formData.append('transactionDescription', this.form.description)
              formData.append('journalList', items)

              for (let i = 0; i < this.form.fileArr.length; i++) {
                // formData.append('fileArr', this.form.fileArr[i])
                if (this.form.fileArr[i].url) {
                  formData.append('fileArr', this.form.fileArr[i].fileId);
                } else {
                  formData.append('fileArr', this.form.fileArr[i]);
                }
              }

              return new Promise((resolve, reject) =>{
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios
                  .post(`/api/v1/accountTransaction/updateJournalEntriesTransaction?companyId=${this.$route.query.companyId}&transactionId=${this.row.id}&transactionNo=${this.row.transactionNo}`, formData)
                  .then(response => {
                    this.notification("Success", "Journal Entry Update", "success")
                    this.$emit('updateList')
                    this.buttonAddChange()
                    // this.$refs.createJournalEntry.close()
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                    reject(error)
                  });
              })
            }else{
              return this.$message({
                type: 'error',
                message: 'Debit and Credit must be equal'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: `Fill in the required fields`
            })
          }
        })
      },
      openModalHistiry() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/accountTransaction/journal-history?companyId=${this.$route.query.companyId}&transactionId=${this.row.id}`)
          .then(response => {
            this.$refs.openHistory.openModal()
            this.historyList = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      checkedTransaction() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/accountTransaction/JournalCheck?companyId=${this.$route.query.companyId}&transactionId=${this.row.id}&transactionNo=${this.row.transactionNo}`)
          .then(response => {
            this.notification("Success", "Journal Entry Check", "success")
            this.status = 'Checked'
            this.$emit('updateList')
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      sendToAccountant() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/journalEntry/send-to-accountant?companyId=${this.$route.query.companyId}&transactionId=${this.row.id}&tab=${this.tab}&transactionNo=${this.row.transactionNo}`)
          .then(response => {
            this.notification("Success", "Send to Accountant", "success")
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      reverseTransaction() {
        this.$confirm('Are you sure you want to Reverse this entry ?', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/accountTransaction/reverseJournalEntriesTransaction?companyId=${this.$route.query.companyId}&transactionId=${this.row.id}&transactionNo=${this.row.transactionNo}`)
            .then(response => {
              this.status = 'Reversed'
              this.$emit('updateList')
              this.notification("Success", "Reverse", "success")
              this.$refs.createJournalEntry.close()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Void canceled'
          });
        });
      },
      disabledDate(time) {
        const date = new Date();
        const previousDate = date.setDate(date.getDate())
        return time.getTime() < previousDate
      },
      openModalReverseByDateTransaction() {
        this.$refs.modalReverseByDate.open()
      },
      reverseByDateTransaction() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/accountTransaction/reverseJournalEntriesTransactionCron?companyId=${this.$route.query.companyId}&transactionId=${this.row.id}&cronDate=${this.reverseByDate}&transactionNo=${this.row.transactionNo}&userId=${this.user.user.id}`)
          .then(response => {
            this.status = 'Reversed'
            this.$emit('updateList')
            this.notification("Success", "Reverse by date", "success")
            this.$refs.modalReverseByDate.close()
            this.$refs.createJournalEntry.close()
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      voidTransaction() {
        this.$confirm(this.status === 'Recorded' ? 'Do you want to VOID current Journal Entry?' : 'Based on current status this JE will  be permanently deleted?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/accountTransaction/voidJournalEntriesTransaction?companyId=${this.$route.query.companyId}&transactionId=${this.row.id}&status=${this.status}&transactionNo=${this.row.transactionNo}&userId=${this.user.user.id}`)
            .then(response => {
              this.status = 'Voided'
              this.$emit('updateList')
              this.notification("Success", this.status === 'Recorded' ? 'Voided' : 'Delete', "success")
              this.$refs.createJournalEntry.close()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Void canceled'
          });
        });
      },
      recordTransaction() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/accountTransaction/JournalRecorder?companyId=${this.$route.query.companyId}&transactionId=${this.row.id}&transactionNo=${this.row.transactionNo}`)
          .then(response => {
            this.notification("Success", "Journal Entry Record", "success")
            this.status = 'Recorded'
            this.$emit('updateList')
            this.$refs.createJournalEntry.close()
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      closeCreateJournalEntry(){
        // this.$refs['form'].resetFields()
        this.form.fileArr = []
        this.buttonAdd = true
        this.glAccountsList = []
        this.currencyList = []
        this.form.items = []
      },
      closeModalReverseByDate() {
        this.reverseByDate = null
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      formatPriceLong(value, fixed) {
        let parts = value.toString().split(".")
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        return parts.join(".")
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        if(columnIndex === 0){
          return 'p-o'
        }
      },
      cellClick(row, column, cell, event){
        console.log('row', row);
        console.log('column', column);
        console.log('event', cell);
        console.log('event', event);
      }
    }
  }
</script>

<style lang="less" scoped>
/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width:100%;
}
/deep/.sweet-modal-overlay {
  z-index:1000;
  .sweet-modal {
    max-width: 100% !important;
  }
}
/deep/.p-o {
  &:hover {
    cursor:pointer;
  }
}
.bill {
  text-align:right;
  h4 {
    line-height:0.6;
    span {
      padding: 0 10px;
    }
  }
  .payment-to-vendor {
    background: rgb(227, 228, 230);
    h3 {
      span {
        padding: 0 10px;
      }
    }
  }
}
/deep/.v-money {
  height: 28px;
  line-height: 28px;
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border: none;
  border-bottom: 2px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px 0 0;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
.text-danger {
  color:red;
}

.file {
  line-height: 40px;
  &__item {
    line-height: 40px;
    display: flex;
      &__viewed{
        display:flex;
        align-items:center;
      }
      &__not-loaded{
        display:flex;
        align-items:center;
      }
  }
  &__name {
    margin-right: 10px;
  }
  &__delete {
    color: red;
  }
}

.pointer {
  cursor: pointer;
}
</style>
